import React, { useRef } from 'react'

import Button from 'components/shared/Button'
import Input from 'components/shared/Input'

import { Title, Text } from 'components/typo'

import delve from 'dlv'
import classnames from 'classnames/bind'
import { useNewsletter } from 'src/hooks/useNewsletter'
import { useClickAway } from 'react-use'
import css from './styles.module.scss'

const cx = classnames.bind(css)

export default function Newsletter({ className, newsletter, onClose }) {
  const portalId = delve(newsletter, 'portalId', '')
  const formGuid = delve(newsletter, 'formGuid', '')
  const title = delve(newsletter, 'title', '')
  const text = delve(newsletter, 'text', '')
  const disclaimer = delve(newsletter, 'disclaimer', '')
  const submitButtonText = delve(newsletter, 'submitButtonText', '')
  const placeholder = delve(newsletter, 'placeholder', '')

  const popInRef = useRef()

  const {
    events: { onChange, onSubmit },
    newsletterState: { email, formStatus, isLoading, isSubmitted },
  } = useNewsletter({
    portalId,
    formGuid,
    popin: true,
  })
  const isValid = formStatus.status === 'success'
  const message = delve(newsletter, formStatus.message, '')

  useClickAway(popInRef, () => {
    onClose && onClose()
  })

  return (
    <div ref={popInRef} className={cx(css.NewsletterPopIn, className)}>
      <div className={css.header}>
        {title && (
          <Title className={css.title} size="small" tag="h3" theme="white">
            {title}
          </Title>
        )}
      </div>
      <div className={css.content}>
        {text && <div className={css.introText}>{text}</div>}
        <form className={cx(css.form)} onSubmit={onSubmit}>
          <label className={css.label} htmlFor={email}>
            Email Address
          </label>
          <Input
            type="email"
            name="email"
            value={email}
            onChange={onChange}
            placeholder={placeholder}
            aria-label={placeholder}
            className={css.emailInput}
            invalid={isSubmitted && !isValid}
            required
          />
          {disclaimer && <div className={css.disclaimer}>{disclaimer}</div>}
          <Button
            fullWidth
            tagName="input"
            type="submit"
            name="submit"
            theme="purple"
            value={submitButtonText}
            disabled={isLoading}
            className={css.submitButton}
          />
          {formStatus && isValid && (
            <Text
              size="smaller"
              theme="green"
              key={message}
              className={cx(css.formMessage, css.successMessage)}
            >
              {message}
            </Text>
          )}

          {formStatus && isSubmitted && !isValid && (
            <Text size="smaller" theme="red" className={cx(css.formMessage)}>
              {message}
            </Text>
          )}
        </form>
      </div>
    </div>
  )
}
